import httpService from '@/modules/common/services/httpService';

const getConversationsCounts = async () => httpService.get('v2/conversations/counts')
  .then((res) => res.data?.attention ?? 0)
  .catch((error) => {
    console.error('[ConversationService] Error fetching conversations counts:', error);
    return 0;
  });

// eslint-disable-next-line import/prefer-default-export
export const conversationService = {
  getConversationsCounts,
};
